import { Stack } from "@fluentui/react/lib/Stack";
import { Text } from "@fluentui/react/lib/Text";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";

import { DataSourceIcon } from "Components/Generic/DataSourceIcon";
import { FilterToolTipContent } from "Components/Generic/FilterToolTipContent";
import { OptionalLink } from "Components/Generic/OptionalLink";
import { WithTranslator } from "Components/Generic/Translator";
import { IRendererProps } from "../IRendererProps";
import { TooltipDirection, TooltipCloseDelay, TooltipOpenDelay } from "../TooltipSettings";
import { useDataSourceRendererStyles } from "./UseDataSourceRendererStyles";

export const DataSourceRenderer = WithTranslator((props: IRendererProps): JSX.Element => {
  const { item, translator, styles } = props;
  const { styleSet, iconStyles } = useDataSourceRendererStyles(styles);
  const { dataSource, dataSourceId, dataSourceUrl } = item;

  return (
    <TooltipHost
      closeDelay={TooltipCloseDelay}
      content={(
        <FilterToolTipContent
          fieldName="dataSourceId"
          rawValue={dataSourceId}
          value={(
            <>
              <Text>{translator.get(`provider.${dataSource}`, dataSource)}</Text>
              <br />
              <Text>{`ID: ${dataSourceId}`}</Text>
            </>
          )}
        />
      )}
      delay={TooltipOpenDelay}
      directionalHint={TooltipDirection}
      hostClassName={styleSet.host}
    >
      <Stack horizontal className={styleSet.root}>
        <Stack.Item>
          <OptionalLink
            alt={translator.get(`provider.${dataSource}`, dataSource)}
            as="a"
            href={dataSourceUrl}
            target="_blank"
          >
            <DataSourceIcon dataSource={dataSource} styleSet={iconStyles} />
          </OptionalLink>
        </Stack.Item>
        <Stack.Item grow={false} className={styleSet.id}>
          <Text>
            <OptionalLink
              alt={translator.get(`provider.${dataSource}`, dataSource)}
              as="a"
              href={dataSourceUrl}
              target="_blank"
            >
              {dataSourceId}
            </OptionalLink>
          </Text>
        </Stack.Item>
      </Stack>
    </TooltipHost>
  );
});
